import { FormControl, FormGroup } from "@angular/forms";
import dayjs from "dayjs";

export function formatarLista(nome: string, dados: any): any {
  return {
    name: nome,
    itens: dados
  };
}

export function aplicarTrim(form: FormGroup): void {
  Object.keys(form.controls).forEach(key => {
    const control = form.get(key);
    if (control && control.value && typeof control.value === 'string') {
      control.setValue(control.value.trim());
    }
  });
}

export function renomearAtributo(objeto: any) {
  if (objeto.hasOwnProperty('itens') && Array.isArray(objeto.itens)) {
    objeto.itens.forEach((item: any) => {
      item.descricao = item.nome;
      delete item.nome;
    });
  }
  return objeto;
}

export function converterItensVaziosEmNull<T>(obj: T): T {
  const convertedObj: { [key: string]: any } = {};

  for (const key in obj) {
    if (obj[key] === "") {
      convertedObj[key] = null;
    } else {
      convertedObj[key] = obj[key];
    }
  }

  return convertedObj as T;
}

export function separarNumeroCenanNewVersion(numeroCena: string | number): { numCena: string | null; complementoCena: string | null } {
  if (typeof numeroCena !== 'string') {
    numeroCena = String(numeroCena);
  }

  const match = numeroCena.match(/^(\d+)([A-Za-z0-9]*)$/);

  return {
    numCena: match?.[1] || null, 
    complementoCena: match?.[2] || null, 
  };
}


export function separarNumeroCena(numeroCena: any) {
  if (typeof numeroCena !== 'string') {
    numeroCena = numeroCena.toString();
  }

  const match = numeroCena.match(/^(\d+)(.*)$/);

  if (match) {
    const numCena = match[1];
    const complementoCena = match[2];
    return { numCena, complementoCena };
  } else {
    if (numeroCena.match(/^\d+$/)) {
      return { numCena: numeroCena, complementoCena: '' };
    }

    const numCena = null;
    const complementoCena = null;
    return { numCena, complementoCena };
  }
}

export function formatarData(obj: any, propriedade: string): void {
  if (obj[propriedade]) {
    obj[propriedade] = dayjs(obj[propriedade]).format('YYYY-MM-DD');
  }
}

export function mascaraLetraMaiuscula(event: any): void {
  const inputValue = event.target.value || '';
  event.target.value = inputValue.toUpperCase();
}

export function montarFilenameDownload(res: any) {
  
  const contentDisposition = res.headers.get('content-disposition');
  const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

  return fileNameMatch[1];
}